import { LogsPage } from "./LogsPage";

const pages = {
  LogsPage,
};
export default pages;
